module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('p', {
    staticClass: "goodslist1",
    staticStyle: {
      "margin": "0",
      "margin-left": "-22px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "31px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "-19px",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0 12px"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "活动标题："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动栏目名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "expand-change": _vm.exchange,
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "状　　态："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.stateId),
      callback: function($$v) {
        _vm.stateId = $$v
      },
      expression: "stateId"
    }
  }, _vm._l((_vm.statearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "34.1%"
    },
    attrs: {
      "label": "活动时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.handleChangeTime
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "33.3%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "33.3%",
      "margin-left": "30px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.getActiveList()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "position": "absolute",
      "right": "30px",
      "top": "-12px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showadd()
      }
    }
  }, [_vm._v("+ 新 增")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "40px"
    }
  }, [
    [_c('el-table', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "data": _vm.goodList,
        "stripe": "",
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "Title",
        "label": "活动标题",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.Title
            }
          }, [_vm._v(_vm._s(scope.row.Title))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "City",
        "label": "所属城市",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.City
            }
          }, [_vm._v(_vm._s(scope.row.City))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ActiveTime",
        "align": "center",
        "label": "活动时间"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.ActiveTime
            }
          }, [_vm._v(_vm._s(scope.row.ActiveTime))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "SignCount",
        "label": "报名人数",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.popNum(scope)
              }
            }
          }, [_vm._v(_vm._s(scope.row.SignCount))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "StatusName",
        "label": "状态",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticStyle: {
              "overflow": "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap"
            },
            attrs: {
              "title": scope.row.StatusName
            }
          }, [_vm._v(_vm._s(scope.row.StatusName))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "",
        "label": "操作",
        "width": "360px",
        "fixed": "right",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.Status != 4) ? _c('span', {
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.changstate(scope)
              }
            }
          }, [_c('i', {
            class: scope.row.Status == 2 ? 'el-icon-circle-close' : 'el-icon-circle-check'
          }), _vm._v("\r\n                " + _vm._s(scope.row.Status == 2 ? "关闭" : "开启") + "\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.Status == 1) ? _c('span', {
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.emitinfo(scope)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-edit-outline"
          }), _vm._v("\r\n                编辑\r\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.Status != 1) ? _c('span', {
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.seeinfo(scope)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-view"
          }), _vm._v("\r\n                  查看\r\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
            directives: [{
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: (_vm.message),
              expression: "message",
              arg: "copy"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: (_vm.onCopy),
              expression: "onCopy",
              arg: "success"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: (_vm.onCopy),
              expression: "onCopy",
              arg: "error"
            }],
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.copy(scope, 1)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-paperclip"
          }), _vm._v("\r\n                  复制PC\r\n              ")]), _vm._v(" "), _c('span', {
            directives: [{
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: (_vm.message),
              expression: "message",
              arg: "copy"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: (_vm.onError),
              expression: "onError",
              arg: "success"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: (_vm.onError),
              expression: "onError",
              arg: "error"
            }],
            staticStyle: {
              "color": "#6786b4",
              "margin-left": "8px",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                return _vm.copy(scope, 2)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-paperclip"
          }), _vm._v("\r\n                  复制小程序\r\n              ")])]
        }
      }])
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "40px"
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), (_vm.dialogVisibledelete) ? _c('addPopNum', {
    ref: "add",
    attrs: {
      "rooid": _vm.rooid
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "外层 Dialog",
      "visible": _vm.outerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.outerVisible = $event
      }
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "30%",
      "title": "内层 Dialog",
      "visible": _vm.innerVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.outerVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.innerVisible = true
      }
    }
  }, [_vm._v("打开内层 Dialog")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("活动管理列表")]), _vm._v(" "), _c('span', {
    staticClass: "goods_red"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b148f2ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/ActivityManagement.vue
// module id = 1740
// module chunks = 3